import React from "react";
import { Box, Skeleton } from "@mui/material";
import { glassCardSx } from "../../theme/njimTheme";

interface CardSkeletonProps {
  count?: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ count = 3 }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
        gap: 2,
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Box key={i} sx={{ ...glassCardSx, mb: 0 }}>
          <Skeleton variant="circular" width={36} height={36} />
          <Skeleton height={14} sx={{ mt: 1.5, width: "40%" }} />
          <Skeleton height={28} sx={{ mt: 1, width: "70%" }} />
          <Skeleton height={12} sx={{ mt: 1, width: "50%" }} />
        </Box>
      ))}
    </Box>
  );
};

export default CardSkeleton;
